module.exports = __webpack_public_path__ + "static/media/cockroach(26).206542dd.PNG";